module.exports = __webpack_public_path__ + "static/media/IntheKitchenwithYeYe.7cab5864.jpg";